export function Card({ title, text }) {
  return (
    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1 border border-[#E5D9F2]">
      <h3 className="text-xl font-semibold mb-3 text-[#2D033B]">
        {title}
      </h3>
      <p className="text-[#5A3D73] leading-relaxed">
        {text}
      </p>
    </div>
  );
}
